
export const LOAD_ACCOUNT_TYPES = 'LOAD_ACCOUNT_TYPES'
export const RECEIVE_ACCOUNT_TYPES = 'RECEIVE_ACCOUNT_TYPES'
